import { useEffect, useRef, useState } from 'react'
import IconButton from '@mui/material/IconButton'
import DownloadIcon from '@mui/icons-material/Download'
import { Box } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import { drawCoordsCard, PLAN_UTIL_VERSION } from '@app/utils/planUtil'

const width = 1024
const height = 638

// qwGk5c8R6wfOvVjh6SJ7
const defaultCardCoords = [
  { value: '{{name}}', x: 46.08, y: 191.4, color: 'black' },

  // External ID and Group ID / planID (Middle left)
  { value: '{{plan.memberData.external_id}}', x: 194.56, y: 265, color: 'black' },
  { value: '{{plan.planData.group_id}}', x: 194.56, y: 300, color: 'black' }, // should this be on planData

  // Coverage details (Bottom left)
  {
    value:
      '{{plan.planData.planDesign.primaryCare.coinsurance.plan.value}}{{plan.planData.planDesign.primaryCare.coinsurance.plan.unit}} /  {{plan.planData.planDesign.primaryCare.coinsurance.patient.value}}{{plan.planData.planDesign.primaryCare.coinsurance.patient.unit}}',
    x: 225,
    y: 485,
    color: 'black',
  },
  {
    value:
      '{{plan.planData.planDesign.specialist.coinsurance.plan.value}}{{plan.planData.planDesign.specialist.coinsurance.plan.unit}} /  {{plan.planData.planDesign.specialist.coinsurance.patient.value}}{{plan.planData.planDesign.specialist.coinsurance.patient.unit}}',
    x: 225,
    y: 515,
    color: 'black',
  },
  {
    value:
      '{{plan.planData.planDesign.urgentCare.coinsurance.plan.value}}{{plan.planData.planDesign.urgentCare.coinsurance.plan.unit}} /  {{plan.planData.planDesign.urgentCare.coinsurance.patient.value}}{{plan.planData.planDesign.urgentCare.coinsurance.patient.unit}}',
    x: 225,
    y: 545,
    color: 'black',
  },
  {
    value:
      '{{plan.planData.planDesign.surgery.coinsurance.plan.value}}{{plan.planData.planDesign.surgery.coinsurance.plan.unit}} /  {{plan.planData.planDesign.surgery.coinsurance.patient.value}}{{plan.planData.planDesign.surgery.coinsurance.patient.unit}}',
    x: 225,
    y: 575,
    color: 'black',
  },

  // Effective Date (Right top)
  {
    value: '02/01/2025',
    // { value: '{{plan.planData.effectiveDate}}',
    x: 731.43,
    y: 267.96,
    color: 'black',
  }, // this should be a hard date. not a timestamp. its a date like a bday not a relative date

  // PCP Label (Right middle)
  { value: 'PCP', x: 620, y: 365, color: 'black' },

  // Pharmacy Info (Right bottom)
  {
    value: '{{plan.planData.planDesign.pharmacyInfo.bin}} ',
    x: 640,
    y: 485,
    color: 'black',
  },
  { value: '{{plan.planData.planDesign.pharmacyInfo.grp}}', x: 640, y: 515, color: 'black' },
  {
    value: '{{plan.planData.planDesign.pharmacyInfo.pcn}}',
    x: 640,
    y: 555,
    color: 'black',
  },
]

const PatientMemberCardRenderer = ({
  name,
  planID,
  cardBackground,
  cardTitle,
  plan,
  cardSource,
  draw = true,
}) => {
  const canvasRef = useRef(null)
  const [hover, setHover] = useState(false)
  const [imageLoaded, setImageLoaded] = useState(false)

  useEffect(() => {
    if (!cardBackground) return

    const canvas = canvasRef.current
    const ctx = canvas.getContext('2d')

    const img = new Image()
    img.crossOrigin = 'anonymous' // Set crossOrigin attribute
    img.onload = () => {
      ctx.drawImage(img, 0, 0, width, height)
      if (draw) {
        drawCoordsCard(
          ctx,
          {
            name,
            plan,
            width,
            height,
            planID,
          },
          cardSource[0]?.coords ? JSON.parse(cardSource[0]?.coords) : defaultCardCoords,
        )
      }
      setImageLoaded(true)
    }

    img.src = cardBackground
  }, [imageLoaded, cardBackground, name, plan, planID])

  const handleDownload = async () => {
    const canvas = canvasRef.current

    if (!canvas) {
      console.error('no canvas to download')
      return
    }

    try {
      const dataUrl = canvas.toDataURL('image/png')

      // Create a download link for the generated image
      const link = document.createElement('a')

      link.href = dataUrl
      link.download = `${cardTitle}.png`

      document.body.appendChild(link) // Append link to the DOM for Safari compatibility
      link.click() // Trigger the download
      document.body.removeChild(link) // Remove the link from the DOM
    } catch (error) {
      console.error('Error generating or downloading the image:', error)
    }
  }

  return (
    <Box
      ke={PLAN_UTIL_VERSION}
      position='relative'
      display='inline-block'
      id={`${cardTitle}_container`}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {!imageLoaded && (
        <Box position='absolute' top='50%' left='50%' transform='translate(-50%, -50%)' zIndex={1}>
          <CircularProgress />
        </Box>
      )}
      <canvas
        ref={canvasRef}
        width={width}
        height={height}
        style={{ width: '100%', height: 'auto', display: 'block' }}
      />
      {hover && imageLoaded && (
        <Box
          position='absolute'
          top={0}
          left={0}
          width='100%'
          height='100%'
          display='flex'
          alignItems='center'
          justifyContent='center'
          bgcolor='rgba(0, 0, 0, 0.3)'
        >
          <IconButton onClick={handleDownload} color='primary' size='large'>
            <DownloadIcon size='large' fontSize='inherit' />
          </IconButton>
        </Box>
      )}
    </Box>
  )
}

export default PatientMemberCardRenderer
